export const CHECKOUT_URL = "https://facelift-en.impultienda.ar/checkout/";

export const images = {
  hero: "https://cdn.magicpatterns.com/uploads/37HdLujRtogEfhQH326tU4/FACELIFT-EN.png",
  author: "https://cdn.magicpatterns.com/uploads/iK7f9ZiKzQwnyMPNTygSGM/MICHAEL_CARTER_-_IMPLANTES.png",
};

export const offerStack = [
  {
    title: "The Facelift Blueprint™ Complete System",
    detail:
      "6 Premium Educational Volumes: Case Assessment Framework, Anatomy & Planning Map, Procedure Blueprint, Case Atlas, Complication Review Atlas, and Learning Archive.",
    value: "$97",
  },
  {
    title: "5 Professional Bonuses",
    detail:
      "30 Educational Case Exercises, The 10-Minute Facelift Review™, The Complication Review Atlas, The Review Cards, and the 30-Day Case Review Challenge.",
    value: "$197",
  },
];

export const offerIncludes = [
  "All six premium volumes",
  "All five professional bonuses",
  "Printable review worksheets",
  "Reusable educational templates",
  "Immediate digital access",
  "Lifetime access to the purchased materials",
  "A 7-day money-back guarantee",
];

export const finalIncludes = [
  "Structured educational review framework",
  "Reusable case-review worksheets",
  "Educational case exercises",
  "Planning and documentation tools",
  "Immediate digital access",
  "Lifetime access to purchased materials",
  "7-day money-back guarantee",
];

export const ctaNote = "One-time payment · Instant digital access · 7-day money-back guarantee";
